import { render, staticRenderFns } from "./OrderVerticalCard.vue?vue&type=template&id=f339b62c"
import script from "./OrderVerticalCard.vue?vue&type=script&lang=js"
export * from "./OrderVerticalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports